import styled from "styled-components";

export const PagamentoContainer = styled.div`
  margin-top: 1rem;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 1rem;

  h4 {
    margin-top: 60.5px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: var(--color-text-lighter);
  }
`;

export const PagamentoGrid = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: baseline;

  width: 100%;
`;
